import { ServiceHistory } from "../types/apis";

export const hasNoServiceHistory = (serviceHistory?: ServiceHistory): boolean =>
  serviceHistory === ServiceHistory.None || serviceHistory === ServiceHistory.NotDue;
